const FLAT_INSTRUMENT_DASHBOARD_PATH = /^\/instrument-dashboard\/([^/]+)\/?$/

const FLAT_QUESTION_DRILLDOWN_PATH = /^\/question-dashboard\/([^/]+)\/([^/]+)\/?$/

const LEGACY_INSTRUMENT_DASHBOARD_PATH =
  /^\/campaigns\/([^/]+)\/loi\/([^/]+)\/instruments\/([^/]+)\/response-dashboard\/?$/

const LEGACY_QUESTION_DRILLDOWN_PATH =
  /^\/campaigns\/([^/]+)\/loi\/([^/]+)\/instruments\/([^/]+)\/questions\/([^/]+)\/response-dashboard\/?$/

export function instrumentDashboardPath(instrumentId: string): string {
  return `/instrument-dashboard/${instrumentId}`
}

export function questionDrillDownPath(instrumentId: string, questionId: string): string {
  return `/question-dashboard/${instrumentId}/${questionId}`
}

export function parseInstrumentDashboardPath(
  pathname: string,
): { instrumentId: string; campaignId?: string; loiId?: string } | null {
  const flat = FLAT_INSTRUMENT_DASHBOARD_PATH.exec(pathname)
  if (flat) return { instrumentId: flat[1] }

  const legacy = LEGACY_INSTRUMENT_DASHBOARD_PATH.exec(pathname)
  if (legacy) {
    return { campaignId: legacy[1], loiId: legacy[2], instrumentId: legacy[3] }
  }

  return null
}

export function parseQuestionDrillDownPath(
  pathname: string,
):
  | { instrumentId: string; questionId: string; campaignId?: string; loiId?: string }
  | null {
  const flat = FLAT_QUESTION_DRILLDOWN_PATH.exec(pathname)
  if (flat) return { instrumentId: flat[1], questionId: flat[2] }

  const legacy = LEGACY_QUESTION_DRILLDOWN_PATH.exec(pathname)
  if (legacy) {
    return {
      campaignId: legacy[1],
      loiId: legacy[2],
      instrumentId: legacy[3],
      questionId: legacy[4],
    }
  }

  return null
}

export function isInstrumentDashboardPath(pathname: string): boolean {
  return parseInstrumentDashboardPath(pathname) !== null
}

export function isQuestionDrillDownPath(pathname: string): boolean {
  return parseQuestionDrillDownPath(pathname) !== null
}
